import { useTranslation } from "react-i18next";
import "./section5.scss";
export const useSection5 = () => {
  const { t } = useTranslation();

  return {
    t,
  };
};
